import { useContext } from 'react'
import { ServiceCancellationContext } from './ServiceCancellationProvider'

export const useServiceCancellation = () => {
  const ServiceCancellationValue = useContext(ServiceCancellationContext)

  if (!ServiceCancellationValue) {
    throw new Error(
      'useServiceCancellation must be used within a ServiceCancellationProvider',
    )
  }

  return ServiceCancellationValue
}
